import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'printer-icon',
  templateUrl: './printer-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrinterIconComponent {}
